/* eslint-disable */
import { Controller } from 'stimulus';
import MediaMatcher from 'lib/media-matcher';

const mediaMatcher = new MediaMatcher();

export default class SearchExploreNavController extends Controller {
  static targets = [
    'item',
    'mobileMenuItem',
  ];

  connect() {
    this.setupPreviewMediaQueries();

    mediaMatcher.evaluateAll();
    mediaMatcher.addListeners();

    window.addEventListener('CloseSearchExploreSubMenus', this.hideMobileMenuItems);
  }

  disconnect() {
    mediaMatcher.removeListeners();
    mediaMatcher.clearQueries();

    window.removeEventListener('CloseSearchExploreSubMenus', this.hideMobileMenuItems);
  }

  addMenuHovers = () => {
    this.itemTargets.forEach((item) => {
      item.addEventListener('mouseenter', this.openSubmenu);
      item.addEventListener('mouseleave', this.closeSubmenu);
    });
  }

  removeMenuHovers = () => {
    this.itemTargets.forEach((item) => {
      item.removeEventListener('mouseenter', this.openSubmenu);
      item.removeEventListener('mouseleave', this.closeSubmenu);
    });
  }

  openSubmenu = (event) => {
    event.currentTarget.classList.add('is-active');
  }

  closeSubmenu = (event) => {
    event.currentTarget.classList.remove('is-active');
  }

  setupPreviewMediaQueries() {
    mediaMatcher.addMediaQuery('(min-width: 941px)',
      () => { this.addMenuHovers(); },
      () => { this.removeMenuHovers(); 
    });
  }

  mobileMenuItemClicked(event) {
    const parentContainer = event.currentTarget.closest('.mobile-menu-group__title');
    
    parentContainer.classList.toggle('is-active');
    this.hideMobileMenuItems(parentContainer);
  }

  hideMobileMenuItems = (parentContainer) => {
    this.mobileMenuItemTargets.forEach((item) => {
      if (item != parentContainer) {
        item.classList.remove('is-active');
      }
    });
  }
}